<template>
    <div class="animated fadeIn">     
        <b-card>
            <div slot="header">Report General Ledger 
                <div class="card-header-actions">
                <button class="btn btn-primary mr-1" @click="process()">
                    <i class="fa fa-play"></i>
                    Process
                </button>
                <button class="btn btn-primary mr-1" @click="print()">
                    <i class="fa fa-print"></i>
                    print
                </button>
                <button class="btn btn-primary mr-1" @click="exportxls()">
                    <i class="fa fa-file-excel-o"></i>
                    Export
                </button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row >
                <b-col lg="4">
                  <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Periode Date</span></b-input-group-prepend>
                        <b-form-input v-model="model.tgl1" type="date" @change="updateTgl2" :state="!$v.model.tgl1.$error"></b-form-input>
                        <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                        <b-form-input v-model="model.tgl2" type="date" @change="updateTgl1" :state="!$v.model.tgl2.$error"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="8">
                      <b-input-group >
                          <b-input-group-prepend><span class="pt-2 pr-1">Account</span></b-input-group-prepend>
                          <b-form-input readonly v-model="model.kodeawinfo"  ></b-form-input>
                          <b-input-group-append>
                              <b-btn text="Button" @click="showLkuCoa('kodeaw')">
                                  <i class="fa fa-search"></i>
                              </b-btn>
                          </b-input-group-append>
                          <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                          <b-form-input readonly v-model="model.kodeakinfo" ></b-form-input>
                          <b-input-group-append>
                            <b-btn text="Button" @click="showLkuCoa('kodeak')">
                                <i class="fa fa-search"></i>
                            </b-btn>
                          </b-input-group-append>
                          <b-form-checkbox class="ml-1 mt-2 text-left" v-model="model.noDim" value=0 unchecked-value=1>With Dimension</b-form-checkbox>
                      </b-input-group>

                </b-col>
            </b-row >
            <b-form-checkbox :disabled="!enableCleanInvCancelation" v-b-tooltip.hover title="hanya untuk GL akun SALES: per satu akun"
            class="ml-1 mt-2 text-left" v-model="model.cleanInvCancelation" value=1 unchecked-value=0>Exclude Invoice Cancelation & Reissued</b-form-checkbox>

      <b-card no-body>
            <b-table
                class="mb-0"
                ref="tableOri"
                sticky-header="600px" outlined responsive striped hover
                style="font-size:smaller;"
                :items="rptLines"
                :fields="tblFields"
                :current-page="tblLcy.page"
                :per-page="tblLcy.limit"
                :sort-by.sync="tblLcy.sortBy"
                :sort-desc.sync="tblLcy.sortDesc"
                :filter="filterInput"
                :filterIncludedFields="filterOn"
                @filtered="onFiltered"                
            >
              <template v-slot:cell(tanggal)="data">
                  {{ data.item.tanggal | moment("DD-MMM-YYYY") }}
                  <!-- <span v-if="(data.item.tanggal)">{{ data.item.tanggal | moment("DD-MMM-YYYY") }}</span> -->
              </template>
                <template v-slot:cell(nomor)="data">
                        <span v-if="(data.item.nomor=='BEGINING')">{{data.item.nomor}}</span>
                        <span v-else ><b-link @click.stop="printJv(data.item)">{{data.item.nomor}}</b-link></span>
                </template>

                <template v-slot:cell(umasuk)="data">
                      {{ data.item.umasuk | numFormat }}
                </template>
                <template v-slot:cell(ukeluar)="data">
                      {{ data.item.ukeluar | numFormat }}
                </template>
                <template v-slot:cell(sakhir)="data">
                      {{ data.item.sakhir | numFormat }}
                </template>
            </b-table>
        <b-row class="m-1">
          <b-col lg="6">            
            <b-row v-if="(filterShow=='Hide')">
                  <b-input-group size="sm">
                      <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch></b-form-checkbox>
                        <b-input-group-prepend> <span class="pr-2">
                            <b> {{ filterShow }}</b>  Filter </span>
                        </b-input-group-prepend>
                      <b-form-input v-model="filter" type="search" placeholder="Type to Search"></b-form-input>
                      <b-input-group-append>
                          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                  </b-input-group>
                  <b-input-group size="sm" class="ml-4">
                      <b-input-group-prepend class="ml-5"> <span class="pr-2">On</span>
                      </b-input-group-prepend>
                      <b-form-checkbox-group v-model="filterOn" class="mt-1">
                        <b-form-checkbox value="nomor">Voucher Number</b-form-checkbox>
                        <b-form-checkbox value="uraian">Description</b-form-checkbox>
                        <b-form-checkbox value="umasuk">Debit Amount</b-form-checkbox>
                        <b-form-checkbox value="ukeluar">Credit Amount</b-form-checkbox>
                      </b-form-checkbox-group>
                  </b-input-group>
                  <label class="text-muted small" style="margin-left:100px;">Leave all unchecked to filter on all data</label>
            </b-row>
            <b-row v-else>
              <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch >
                <b> {{ filterShow }}</b>  Filter
              </b-form-checkbox>
            </b-row>
          </b-col>
          <b-col lg="6">
            <div style="display: flex;margin:0;padding:0;">
                <div style="margin:0;padding:5px;width:500px; text-align:right;">
                    Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                    to <span v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)">{{tblLcy.total}}</span> <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                    of {{tblLcy.total}} ,   <span class="mr-1">limit per page :</span> 
                    <select  v-model="tblLcy.limit"  style="width:60px;">
                      <option>10</option>
                      <option>15</option>
                      <option>20</option>                            
                      <option>25</option>
                      <option>30</option>                            
                      <option>40</option>                            
                      <option>50</option>                            
                      <option>60</option>                            
                      <option>70</option>                            
                      <option>80</option>                            
                      <option>90</option>                            
                    </select>
                </div>
                <div>
                    <b-pagination  class="ml-1" 
                      align="left"
                      :total-rows="tblLcy.total"
                      :per-page="tblLcy.limit"
                      v-model="tblLcy.page"
                    ></b-pagination>
                </div>
            </div>
          </b-col>
        </b-row>
      </b-card>

        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe :src="reportUrl" frameborder="0"></iframe>
        </b-modal>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun" :allowHeader="true"></lku-coa>
        </b-modal>        
    </div>
</template>

<style lang="scss" scoped>
 
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import lkuCoa from "../lookup/lkuCoa";
import buku from "../../apis/buku";
import gl from "../../apis/gl";
import myNumber from "../../components/my-number";
import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
        // kodeaw: { required },
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      model: {kodeaw:'',tgl1:'',tgl2:'', tabIndex:1, noDim:0, cleanInvCancelation:0},
      isLoading: false,
      horizontal: true,
      reportUrl: null,
      showReport:false,
      tahun:moment(this.$store.state.user.tglaktif).format('YYYY'),
      lkuCoaShow:false,
      lkuCoaCaller:'kodeaw',
      rptLines : [],
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
      },
      filterShow:'Show',
      filter: null,
      filterOn: [],   
      filterInput:null,
      salesAccount:[],enableCleanInvCancelation:false
    };
  },
components: { Loading, lkuCoa, myNumber },  
computed:{
    dimension(){
      return this.$store.state.dimension;
    },
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    tblFields(){
      const fields=[
          {
            key: "tanggal",
            label: "Trx. Date",
            thStyle: "width:90px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "nomor",
            label: "Trx. Number",
            sortable: true
          },
        {
          key: "uraian",
          label: "Description",
        },
        {
          key: "createby",
          label: "Create By",
          sortable: true
        },
        {
          key: "umasuk",
          label: "Debit (LCY)",
          thStyle: "width:140px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true
        },
        {
          key: "ukeluar",
          label: "Credit (LCY)",
          thStyle: "width:140px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true
        },
        {
          key: "sakhir",
          label: "End Balance  (LCY)",
          thStyle: "width:140px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true
        },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: `${dims[i].value}Txt`,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
      return fields;
    },    
  },

  watch:{
    filterShow: function(newval) {
      setTimeout(() => {
           if (this.filterShow=='Show') {
             this.filterInput='';
             this.filter='';
            }
      }, 200);
    },
    filter: function(newval) {
      setTimeout(() => {
           if ( this.filterInput!=newval) this.filterInput=newval;
      }, 800);
    },
    
  },  

created: async function (){
    // const { user } = this.$store.state;
//  this.tahun=moment(user.tglaktif).format('YYYY');
    if (this.$route.params.tgl1 && this.$route.params.tgl2 && this.$route.params.kodeaw) {
        this.model.kodeaw = this.$route.params.kodeaw;
        this.model.kodeak = this.$route.params.kodeak || this.model.kodeaw;
        this.model.kodeawinfo = this.$route.params.kodeaw;
        this.model.kodeakinfo = this.$route.params.kodeak || this.model.kodeaw;
        this.model.tgl1=this.$route.params.tgl1;
        this.model.tgl2=this.$route.params.tgl2;
        this.process();
    } else {
         var tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        this.model.tgl1=`${tgl2.format('YYYY-MM')}-01`;
        this.model.tgl2=tgl2.format('YYYY-MM-DD');
        this.tahun=tgl2.format('YYYY');
    }
      const resSalesAcc = await gl.salesAccount().catch((err) => {
        console.log('error get salesAccount', err);
        return [];
      });
      this.salesAccount = Array.isArray(resSalesAcc) ? resSalesAcc : [];
    this.$watch("model.kodeaw", function (newval) {
      if ((newval) && (!(this.model.kodeak) || (newval == this.model.kodeak))) {
        const ada = Array.isArray(this.salesAccount) && this.salesAccount.find((e)=>e.saleCrCode == newval);
        if (ada) {
          this.enableCleanInvCancelation=true;
        } else {
          this.enableCleanInvCancelation=false;
          this.model.cleanInvCancelation=0;
        }

      } 
      else {
        this.enableCleanInvCancelation=false;
        this.model.cleanInvCancelation=0;
      }
    });
    this.$watch("model.kodeak", function (newval) {
      if ((newval) && ((this.model.kodeaw) || (newval == this.model.kodeaw))) {
        const ada = Array.isArray(this.salesAccount) && this.salesAccount.find((e)=>e.saleCrCode == newval);
        if (ada) {
          this.enableCleanInvCancelation=true;
        } else {
          this.enableCleanInvCancelation=false;
          this.model.cleanInvCancelation=0;
        }
      } else {
        this.enableCleanInvCancelation=0;
        this.model.cleanInvCancelation=0;
      }
    });

},
methods:{
    updateTgl1: function() {
      setTimeout(() => {
        var tgl2 = moment(this.model.tgl2, 'YYYY-MM-DD');
        if (!this.model.tgl1){
            this.model.tgl1=`${tgl2.format('YYYY-MM')}-01`;
            this.tahun=tgl2.format('YYYY');
            this.$forceUpdate();
        } else {
            var tgl1 = moment(this.model.tgl1, 'YYYY-MM-DD');
            if (tgl1.format('YYYY') !== tgl2.format('YYYY')){
                this.model.tgl1=`${tgl2.format('YYYY')}-01-01`;
                this.tahun=tgl2.format('YYYY');
                this.$forceUpdate();
            }
        }
        
      }, 1000);
    },
    updateTgl2: function() {
      setTimeout(() => {
        var tgl1 = moment(this.model.tgl1, 'YYYY-MM-DD');
        if (!this.model.tgl2){
            this.model.tgl2=`${tgl1.format('YYYY')}-12-31`;
            this.tahun=tgl1.format('YYYY');
            this.$forceUpdate();
        } else {
            var tgl2 = moment(this.model.tgl2, 'YYYY-MM-DD');
            if (tgl1.format('YYYY') !== tgl2.format('YYYY')){
                this.model.tgl2=`${tgl1.format('YYYY')}-12-31`;
                this.tahun=tgl1.format('YYYY');
                this.$forceUpdate();
            }
        }        
      }, 1000);
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
      // this.totalUmasuk = filteredItems.reduce((a, b) => a + b.umasuk, 0);
      // this.totalUkeluar = filteredItems.reduce((a, b) => a + b.ukeluar, 0);
    },     
    clearFilter() {
          this.filterOn= []   
          this.filter= '';   
    } ,
    process: async function(ctx) {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
          try {
              this.isLoading=true;
                const model = {};
                for (var key in this.model) {
                    model[key] = this.model[key];
                }
                model.tgl1= moment(this.model.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.model.tgl2).format('YYYY-MM-DD');
                this.rptLines= await gl.rptgl(model);      
                this.tblLcy.total = this.rptLines.length;        
                this.isLoading=false;      
          } catch (error) {
              this.isLoading=false;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
          }


       }
    },

    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            try {
                this.showReport=true;
                const model = {};
                for (var key in this.model) {
                    model[key] = this.model[key];
                }
                model.tgl1= moment(this.model.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.model.tgl2).format('YYYY-MM-DD');
                this.reportUrl= await gl.rptglprint(model);
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
            } catch (error) {
              this.isLoading=false;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }
       }
    },
    exportxls: async function() {
        if (this.invalidFilter) {
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                const model = {};
                for (var key in this.model) {
                    model[key] = this.model[key];
                }
                model.tgl1= moment(this.model.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.model.tgl2).format('YYYY-MM-DD');
                const response = await gl.rptglexport(model);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `GeneralLedger_${model.tgl2}.xlsx`);
                document.body.appendChild(link);
                link.click();

                this.isLoading=false;    
            } catch (error) {
              this.isLoading=false;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }
       }
    },
    confirmAction: function() {
        toastr.info('Klik Pada kolom JV.NUMBER untuk PRINT VOUCHER');
    },
    printJv: async function(data){
       if ((data.kodeacc) && (data.nomor !== 'BEGINING') && (data.nomor !== '')) {
          try {              this.showReport=true;

              this.reportUrl= await buku.printjv({ nomor: data.nomor, tanggal:moment(data.tanggal).format('YYYY-MM-DD'), kodejurnal: data.kodejurnal});

          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } 
    },
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
        if (this.lkuCoaCaller==='kodeaw'){
            this.model.kodeawinfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.model.kodeaw = _selected.kodeacc;
        } else {
            this.model.kodeakinfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.model.kodeak = _selected.kodeacc;
        }
        this.lkuCoaShow=false;
    },
    close(){
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'accounting.gl')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        //   router.push("/accounting/home");
          router.push({path:"home"});
      }

    }
    
  }
};
</script>
